/** Validate the one-use server handoff before leaving Hans. Never persist its token. */
export function schedulerSignInTarget(result, businessId, now = Date.now()) {
  const target = new URL(result?.url);
  const expires = Date.parse(result?.expires_at);
  if (result?.business_id !== businessId || !businessId || target.protocol !== "https:" ||
      target.username || target.password || target.pathname !== "/admin/login/platform" ||
      target.search || !/^#token=[A-Za-z0-9_-]{43}$/.test(target.hash) ||
      !Number.isFinite(expires) || expires <= now || expires > now + 125_000) {
    throw new Error("The scheduling sign-in link is no longer valid. Please try again.");
  }
  return target.href;
}

export const schedulingLabel = (connection) => connection.org_id ? connection.name : `Personal · ${connection.name}`;
